export default {
      id: "duree_hebdo-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#duree_hebdo-usage",
      toString: function () {
        return this.url;
      }
    }